import {FULLFILL_AVAILABLE_CASE_TYPES} from '@/store/modules/cases/mutations/available'

export default {
    [FULLFILL_AVAILABLE_CASE_TYPES](state, value) {
        state.availableCaseTypes = value
    }
}